import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Footer from "../../components/Footer/Footer";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { TiClipboard, TiEdit, TiDelete } from "react-icons/ti";
import { IoCloseCircleOutline } from "react-icons/io5";
import { fetchData, deleteData } from "../../services/apiService";
import useAlertUtils from "../../utils/common.utils";

function TestIndexPage() {
  const token = localStorage.getItem("token");

  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
      .join("")
  );
  const decoded = JSON.parse(jsonPayload);

  const navigate = useNavigate();
  const { alertError, alertSuccess } = useAlertUtils();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [testName, setTestName] = useState("");
  const [testId, setTestId] = useState(null);
  const [testData, setTestData] = useState([]);

  const getUsersTestData = async (decoded) => {
    try {
      const data = await fetchData(
        `api/test/get-users-labTests/${decoded.userId}`
      );
      if (data.success === true) {
        const sortedData = data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTestData(sortedData);
      } else {
        alertError("Error Fetching User Data");
      }
    } catch (error) {
      alertError("Error -> ", error);
    }
  };

  useEffect(() => {
    getUsersTestData(decoded);
  }, []);

  const handleDeleteTest = async (id) => {
    try {
      const res = await deleteData(`/api/test/delete-labTest/${id}`);
      if (res.success === true) {
        alertSuccess("Test Deleted Successfully");
        setIsModalOpen(false);
        getUsersTestData(decoded);
      }
    } catch (error) {
      alertError("Error Deleting Data");
    }
  };

  const handleNavigate = (token) => {
    if (token) {
      navigate("/app/add-new-test");
    } else {
      navigate("/register");
    }
  };
  return (
    <div className="appointment-page">
      {token ? <Header></Header> : <PreLoginHeader></PreLoginHeader>}
      <div className="main_content">
        <div className="container">
          <div className="main_block">
            <div className="top_bar">
              <div className="left_part">
                <div className="main_title">Lab Tests</div>
              </div>
              <div className="right_part">
                <div className="right_part_inner">
                  <button
                    onClick={() => handleNavigate(token)}
                    className="btn btn-primary add_kit"
                  >
                    Add New Test
                  </button>
                </div>
              </div>
            </div>
            <div className="table_wrapper dashboard">
              <div className="table_inner">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="right">Test Name</TableCell>
                        <TableCell align="right">Laboratory Name</TableCell>
                        <TableCell align="right">Laboratory Location</TableCell>
                        <TableCell align="right">Added Date</TableCell>
                        <TableCell align="right">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {testData &&
                        testData.map((row) => (
                          <TableRow
                            key={row?.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell align="right">
                              <span className="mob_head">Test Name</span>
                              {row?.testName}
                            </TableCell>
                            <TableCell align="right">
                              <span className="mob_head">Laboratory Name</span>
                              {row?.laboratoryName}
                            </TableCell>

                            <TableCell align="right">
                              <span className="mob_head">
                                Laboratory Location
                              </span>
                              {row?.laboratoryLocation}
                            </TableCell>

                            <TableCell align="right">
                              <span className="mob_head">Added Date</span>
                              {new Date(row?.createdAt).toLocaleDateString(
                                "en-US",
                                {
                                  weekday: "long",
                                  month: "long",
                                  day: "numeric",
                                }
                              )}
                            </TableCell>
                            <TableCell align="right">
                              <span className="mob_head">Action</span>
                              <div style={{ display: "flex", gap: "10px" }}>
                                <TiClipboard
                                  onClick={() => {
                                    navigate(`/app/test-details/${row?.id}`);
                                  }}
                                  size={30}
                                  color="black"
                                  cursor="pointer"
                                />
                                <TiEdit
                                  onClick={() => {
                                    navigate(`/app/edit-test/${row?.id}`);
                                  }}
                                  cursor="pointer"
                                  size={30}
                                  color="black"
                                />
                                <TiDelete
                                  onClick={() => {
                                    setIsModalOpen(true);
                                    setTestId(row?.id);
                                    setTestName(row?.testName);
                                  }}
                                  size={30}
                                  color="red"
                                  cursor="pointer"
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
      {isModalOpen && (
        <div
          className="delete-modal-overlay"
          onClick={() => setIsModalOpen(false)}
        >
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="delete-modal-header">
              <div onClick={() => setIsModalOpen(false)}>
                <IoCloseCircleOutline cursor="pointer" size={45} color="red" />
              </div>
            </div>
            <div className="delete-modal-body">
              <h2>Delete Test</h2>
              <p>
                Are you sure you want to delete{" "}
                <span style={{ color: "red" }}>{testName}</span> laboratory
                test?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "40px",
                }}
              >
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                >
                  No
                </button>
                <button
                  onClick={() => {
                    handleDeleteTest(testId);
                  }}
                  className="btn btn-primary add_kit"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TestIndexPage;
